export const inputType = {
  type: 'union' as const,
  members: ['none' as const, 'boolean' as const],
};
